import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ExternalUserAssociationRequest} from '../../models/external-user-association-request.model';

@Injectable({
  providedIn: 'root',
})
export class ExternalUserService {
  private BASE_ROUTE = 'external-user';

  constructor(private http: HttpClient) {}

  async associateExternalUser(
    externalService: string,
    externalUser: string,
    verificationCode: string
  ): Promise<void> {
    const url = `${environment.BASE_PATH}/${this.BASE_ROUTE}/associate`;
    const request: ExternalUserAssociationRequest = {
      externalService,
      externalUser,
      verificationCode
    };
    const response$ = this.http.post<void>(url, request);

    return await lastValueFrom(response$);
  }
}
